<template>
  <Layout>


    <div class="row">
      <div class="col-lg-12">
        <div class="card border border-radius-12">

          <div class="card-body table mb-0">
            <div class="toolbar-container px-3">
              <div class="toolbar-row d-flex align-items-center justify-content-between mb-2">
                <PageHeader :title="title" :items="items" class="poppins fw-normal ps-0 text-nowrap" />
                <div class="d-flex gap-2 flex-wrap p-0 buttons-container">
                  <CustomButton 
                    :buttonText="downloadReportProcessing ? 'Please wait...' : 'Download Report'"
                    class="p-0"
                    :loading = "downloadReportProcessing"
                    @click="downloadReport" 
                  />
                  <CustomLinkButton 
                    buttonText="Add New" 
                    class="p-0"
                    :linkTo="{ name: 'add-user', query: { redirect_back_to: this.$route.fullPath } }"
                  />
                </div>
              </div>

              <div class="toolbar-row d-flex gap-2 align-items-center">
                <searchInput @getSearched="handleSearch" class="p-0" />
                <pageSize @getPageSize="handlePageSize" class="page-size-btn p-0" />
                <div class="sort-btn p-0">
                  <select @change="filtration" v-model="sort_by"
                    class="form-select sm-select rounded-pill fs-16 sort-filter px-3" aria-label="Sort By">
                    <option value="" selected disabled>Sort By</option>
                    <option value="alphabetically">User Name (A-Z)</option>
                    <option value="created_on">Registered</option>
                    <option value="user_id">Id</option>
                  </select>
                </div>       
              </div>
            </div>
            <GeneralTable :isProcessing="processing" :items="items" :fields="fields" @deleteItem="deleteUser"
              @editItem="userUpdate" :editUrl="'user-details'" :showEyeButton="true" @showItem="showUserDetails">
            </GeneralTable>
            <Pagination @paginator="allUsers" :pagination="paginatelinks" :showing="paginate"
              @page-changed="handlePageChange" />
            <!-- end table-responsive -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../../../layouts/static/main";
import PageHeader from "@/components/static/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import $ from "jquery";
import GeneralTable from "../../../../../components/MagicTable/GeneralTable.vue";
import Pagination from "../../../../../components/general/pagination.vue";
import searchInput from "../../../../../components/general/searchInput.vue";
import pageSize from "../../../../../components/general/pageSize.vue";
import CustomButton from "../../../../../components/CustomButton.vue";
import CustomLinkButton from "../../../../../components/CustomLinkButton.vue";
export default {
  page: {
    title: "Canceled Membership Users",
    meta: [
      {
        name: "add-user",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    GeneralTable,
    Pagination,
    searchInput,
    pageSize,
    CustomButton,
    CustomLinkButton,
  },

  data() {
    return {
      currentPageNumber: null,
      fields: [
        { key: 'select', label: 'Select', sortable: false },
        { key: 'id' },
        { key: 'avatar_with_title', label: 'User Name' },
        { key: 'email', tdClass: 'align-middle' },
        { key: 'mobile', label: 'Phone', tdClass: 'align-middle' },
        { key: 'subscription', label: 'Subscription', tdClass: 'align-middle' },
        // { key: 'subscription_status', label: 'Subscription Status', tdClass: 'align-middle' },
        { key: 'subscription_start_date', label: 'Subscription Start Date', tdClass: 'align-middle' },
        { key: 'subscription_end_date', label: 'Subscription End Date', tdClass: 'align-middle' },
        { key: 'Duration', label: 'Subscription Type', tdClass: 'align-middle' },
        { key: 'payment_method', label: 'Payment Method', tdClass: 'align-middle' },
        { key: 'last_shipment_date', label: 'Last Shipment Date', tdClass: 'align-middle' },
        { key: 'last_shipment_status', label: 'Last Shipment Status', tdClass: 'align-middle' },
        { key: 'total_shipments', label: 'Total Shipments', tdClass: 'align-middle' },
        { key: 'registeredon', label: 'Registered On', tdClass: 'align-middle' },
        { key: 'action', tdClass: 'align-middle' },
      ],
      sort_by: '',
      selectedRows: [],
      items: [],
      currentPage: 1,
      itemsPerPage: 10,
      multipuleIds: [],
      selectAll: false,
      loading: true,
      users: null,
      paginatelinks: [],
      title: "Canceled Membership Users",
      processing: false,
      paginate: {},
      pageSize: 10,
      downloadReportProcessing:false,
      searchTerm: null,
    };
  },

  mounted() {
    let url = null;
    if (this.$route.query.currentPage) {
      url = process.env.VUE_APP_BASEURL + '/all-users?page=' + this.$route.query.currentPage;
    }
    this.allUsers({ url });
    this.processing = true;
  },
  computed: {
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.items.slice(start, start + this.itemsPerPage);
    }
  },
  methods: {
    showUserDetails(id) {
      this.$router.push({ name: 'user-details', params: { id } });
    },
    handlePageChange(pageNumber) {
      if (pageNumber <= 0) {
        this.triggerSwal("Page not found. Please enter a valid page number.", "error");
        return;
      }

      const lastPageUrl = this.paginate?.last_page;
      console.log(pageNumber);
      let lastPage = 1;
      if (lastPageUrl) {
        const match = lastPageUrl.match(/page=(\d+)/);
        if (match && match[1]) {
          lastPage = parseInt(match[1], 10);
        }
      }

      if (pageNumber > lastPage) {
        this.triggerSwal("Page not found. Please enter a valid page number.", "error");
        return;
      }
      const baseUrl = "all-users";
      const pageUrl = `${baseUrl}?page=${pageNumber}`;
      this.allUsers({ url: pageUrl });
    },
    deleteUser(id) {
      let apiUrl = `delete-user/`;
      let confirmationMessage = "User deleted successfully."
      this.processing = true;
      this.deleteIt(apiUrl, id, confirmationMessage)
        .then(() => {
          this.processing = false;
          this.allUsers({});
        }).catch(error => {
          console.error('Error deleting job:', error);
          this.processing = false;
        });
      console.log('Received ID from child:', id);
    },
    handleSearch(searchItem) {
      this.searchTerm = searchItem;
      this.allUsers({ searchItem });
    },
    filtration() {
      this.allUsers({ sortBy: this.sort_by });
    },
    updateCurrentPage(newPage) {
      this.currentPage = newPage;
    },
    handlePageSize(newPageSize) {
      this.pageSize = newPageSize || 10;
      this.allUsers({ pageSize: this.pageSize });
    },
    randerData(response) {
      this.currentPageNumber = response.data.data.current_page;
      this.paginate = {
        first_page: response.data.data.first_page_url,
        last_page: response.data.data.last_page_url,
        links: response.data.data.links,
        from: response.data.data.from,
        to: response.data.data.to,
        total: response.data.data.total,
      };

      this.paginatelinks = this.paginate.links.map(item => ({
        url: item.url,
        label: item.label,
        active: item.active,
      }));
      let users = Array.isArray(response.data.data.data) && response.data.data.data.length > 0
        ? response.data.data.data
        : [];
      this.items = users.map(user => ({
        id: user.id,
        avatar: user.avatar,
        name: user.full_name,
        email: user.email,
        mobile: user.mobile,
        t_shirt_size: user.t_shirt_size,
        subscription: user.subscriptions[0]?.subscription_plan?.name ?? 'Not Subscribed',
        // subscription_status: user.subscriptions[0]?.stripe_status ?? "N/A",
        subscription_start_date: user.subscriptions[0]?.created_at_formatted ?? "N/A",
        subscription_end_date: user.subscriptions[0]?.subscription_end_date? this.formatDateTime(user.subscriptions[0].subscription_end_date): "N/A",
        Duration: user.subscriptions[0]?.subscription_plan?.interval === 'month'
          ? 'Monthly'
          : user.subscriptions[0]?.subscription_plan?.interval === 'year'
          ? 'Yearly'
          : 'Not Specified',
        payment_method: user.pm_type ? user.pm_type + ' ' + 'xxxxxxxxxxxx' + user.pm_last_four : 'Not Attached',
        registeredon: user.created_at_formatted,
        last_shipment_date: user.shipments[0]?.shipDate ?? "N/A",
        last_shipment_status: user.shipments[0]?.orderStatus ?? "Not Shipped",
        total_shipments: user.shipments.length,
      }));
      this.processing = false;
    },
      formatDateTime(isoDate) {
            if (!isoDate) return "N/A";
            const date = new Date(isoDate);
            if (isNaN(date.getTime())) {
                return isoDate;
            }

            const options = {
                year: "numeric",
                month: "short",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            };

            return date.toLocaleString(undefined, options);
      },

    allUsers({ url = null, searchItem = null, sortBy = null, pageSize = this.pageSize } = {}) {
      this.processing = true;
      let endPoint = "all-users";
      endPoint = url ? url : endPoint;
      this.$axios
        .get(endPoint, {
          params: {
            search: searchItem,
            sort_by: sortBy,
            page_size: pageSize,
            with_subscriptions: true,
            with_shipments: true,
            // subscription_status: 'expired,canceled',
            subscription_status: 'canceled',
            cancel_reason_type: 'canceled',
          }
        })
        .then((response) => {
          console.log('User Data:', response.data);
          setTimeout(() => this.randerData(response), 1500);
        })
        .catch((error) => {
          console.log(error.response);
          this.processing = false;
        });
    },

    updateRecords(records) {
      this.users = records;
      this.links = records;
    },
    // Record update Function
    userUpdate: function (id) {
      this.$router.push({
        name: "free-update-user",
        params: { id: id },
        query: { currentPage: this.currentPageNumber,redirect_back_to: this.$route.fullPath },
      });
    },
    selectAllRecord() {
      if (this.selectAll) {
        let ids = [];
        this.users.forEach((element) => {
          ids.push(element.id);
        });
        this.multipuleIds = [...new Set(ids)];
        console.log(this.multipuleIds);
      } else {
        this.multipuleIds = [];

        console.log(this.multipuleIds);
      }
    },
    deleteBulk() {
      this.$axios
        .post("delete-user-bulk", { ids: this.multipuleIds })
        .then((response) => {
          this.allUsers({});
          this.triggerSwal(response.data.message, "success");
          this.selectAll = false;
          this.multipuleIds = [];
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    async downloadReport() {
    if (this.downloadReportProcessing) return;
    this.downloadReportProcessing = true;

    try {
      const total = this.paginate?.total || this.items.length;
      let allItems = [];

      if (total <= this.items.length) {
        allItems = this.items;
      } else {
        const response = await this.$axios.get("all-users", {
          params: {
            search: this.searchTerm,
            sort_by: this.sort_by,
            page_size: total,
            with_subscriptions: true,
            with_shipments: true,
            // subscription_status: "expired,canceled",
            subscription_status: "canceled",
            cancel_reason_type: "canceled",
          },
        });

        const users = Array.isArray(response.data.data.data)
          ? response.data.data.data
          : [];

        allItems = users.map(user => ({
          id: user.id,
          avatar: user.avatar,
          name: user.full_name,
          email: user.email,
          mobile: user.mobile,
          t_shirt_size: user.t_shirt_size,
          subscription: user.subscriptions[0]?.subscription_plan?.name ?? "Not Subscribed",
          subscription_status: user.subscriptions[0]?.stripe_status ?? "N/A",
          subscription_start_date: user.subscriptions[0]?.created_at_formatted ?? "N/A",
          subscription_end_date: user.subscriptions[0]?.subscription_end_date
            ? this.formatDateTime(user.subscriptions[0].subscription_end_date)
            : "N/A",
          Duration: user.subscriptions[0]?.subscription_plan?.interval === 'month'
          ? 'Monthly'
          : user.subscriptions[0]?.subscription_plan?.interval === 'year'
          ? 'Yearly'
          : 'Not Specified',
          payment_method: user.pm_type
            ? user.pm_type + " " + "xxxxxxxxxxxx" + user.pm_last_four
            : "Not Attached",
          registeredon: user.created_at_formatted,
          last_shipment_date: user.shipments[0]?.shipDate ?? "N/A",
          last_shipment_status: user.shipments[0]?.orderStatus ?? "Not Shipped",
          total_shipments: user.shipments.length,
        }));
      }

      if (!allItems.length) {
        this.triggerSwal("No data available to download.", "warning");
        return;
      }

      const headers = [
        "ID",
        "User Name",
        "Email",
        "Phone",
        "Subscription",
        // "Subscription Status",
        "Subscription Start Date",
        "Subscription End Date",
        "Subscription Duration",
        "Payment Method",
        "Last Shipment Date",
        "Last Shipment Status",
        "Total Shipments",
        "Registered On",
      ];

      const rows = allItems.map(user => ([
        user.id,
        user.name,
        user.email,
        user.mobile,
        user.subscription,
        // user.subscription_status,
        user.subscription_start_date,
        user.subscription_end_date,
        user.Duration,
        user.payment_method,
        user.last_shipment_date,
        user.last_shipment_status,
        user.total_shipments,
        user.registeredon,
      ]));

      let csvContent = "";
      csvContent += headers.join(",") + "\n";

      rows.forEach(row => {
        csvContent += row
          .map(value => `"${String(value ?? "").replace(/"/g, '""')}"`)
          .join(",") + "\n";
      });

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `canceled-membership-users-report-${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      this.triggerSwal("Something went wrong while generating report.", "error");
    } finally {
      this.downloadReportProcessing = false;
    }
  },
  },
};
</script>
<style scoped>
.toolbar-container {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
}

.toolbar-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  width: 100%;
}

.sort-btn
{
  width: 100%;
  flex: 0 0 100%;
}

@media (min-width: 576px) {
  .sort-btn{
    width : 145px;
    flex : 0 0 145px;
  }
}

@media (max-width : 576px){
  .card-body{
    padding : 0.25rem !important;
  }
  .toolbar-row {
    justify-content: flex-start;
  }

  .toolbar-row:first-child {
    flex-direction: column;
    align-items: flex-start;
  }
  .buttons-container{
    width : 100%;
  }
}
@media (max-width: 768){
  .table > :not(caption) > * > *
  {
    padding: 0.25rem !important;
  }
}
</style>